import type { ChatRoom } from "@/react/types/Chat/ChatRoom";
import type { ChatRoomMessage } from "@/react/types/Chat/ChatRoomMessage";
import { Reactions } from "@circle-react/components/Reactions";
import { StopSpotlightButton } from "./StopSpotlightButton";

interface BottomActionsProps {
  chatRoom: ChatRoom;
  currentCommunityMemberId: number;
  isAdmin: boolean;
  isCurrentSpotlightedItem: boolean;
  isRenderedOnHeader: boolean;
  isSpotlighted: boolean;
  isViewOnlyMasquerading: boolean;
  message: ChatRoomMessage;
}

export const BottomActions = ({
  message,
  chatRoom,
  currentCommunityMemberId,
  isSpotlighted,
  isCurrentSpotlightedItem,
  isAdmin,
  isRenderedOnHeader,
  isViewOnlyMasquerading,
}: BottomActionsProps) => {
  const shouldShowReactions = message.reactions.length > 0;
  const shouldShowStopSpotlightButton = isSpotlighted && isAdmin;

  if (!shouldShowReactions && !shouldShowStopSpotlightButton) {
    return null;
  }

  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-1">
      {shouldShowReactions && (
        <Reactions
          reactions={message.reactions}
          currentCommunityMemberId={currentCommunityMemberId}
          reactionableId={message.id}
          reactionableType="chat_room_message"
          isRenderedOnHeader={isRenderedOnHeader}
          isViewOnlyMasquerading={isViewOnlyMasquerading}
        />
      )}
      {shouldShowStopSpotlightButton && (
        <StopSpotlightButton
          message={message}
          chatRoom={chatRoom}
          isCurrentSpotlightedItem={isCurrentSpotlightedItem}
        />
      )}
    </div>
  );
};
